import * as React from "react";
import {
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
} from "@mui/material";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";
import { ApiBaseUrl, AppUrl } from "../../config";
import { fetchData } from "../../common/services/ApiClient";
import { getCookiebyName } from "../../common/services/Utilities";
import { useNavigate } from "react-router-dom";

export default function MaintenanceDashboard() {
  const [bannerData, setBannerData] = React.useState({
    is_active: "",
    description: "",
    ID: "",
    title: "",
    disabled: "",
  });
  const navigate = useNavigate();
  const [title, setTitle] = React.useState(bannerData.title);
  const [description, setDescription] = React.useState(bannerData.title);
  const [status, setStatus] = React.useState(bannerData.is_active);
  const [disable, setDisable] = React.useState(bannerData.disabled);
  const token: string =
    Object.fromEntries(new URLSearchParams(window.location.search).entries())
      .token || "";
  const user = getCookiebyName("uuid");
  const handleTitleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(event.target.value);
  };
  const handleDescriptionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setDescription(event.target.value);
  };
  const handleStatusChange = (event: SelectChangeEvent) => {
    setStatus(event.target.value);
  };
  const handleDisableChange = (event: SelectChangeEvent) => {
    setDisable(event.target.value);
  };
  React.useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      (async () => {
        await fetch(
          `${ApiBaseUrl()}/maintenance/isAdmin?token=${token}&user=${user}`,
        )
          .then((response) => {
            if (!response.ok) {
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((response) => {
            //add redirct if not true
            if (!response.authorized) {
              navigate(AppUrl("HomePage"));
            }
          })
          .catch((error: Error) => {
            console.error(error);
          });
      })();
      return () => {
        isMounted = false;
      };
    }
  }, [navigate, token, user]);

  React.useEffect(() => {
    let isMounted = true;

    (async () => {
      await fetchData(`${ApiBaseUrl()}/maintenance`)
        .then((response: any) => {
          if (isMounted && response.data) {
            if (response.data[0]) {
              setBannerData(response.data[0]);
              setTitle(response.data[0].title);
              setStatus(response.data[0].is_active);
              setDescription(response.data[0].description);
              setDisable(response.data[0].disable_content);
            }
          }
        })
        .catch((error: Error) => {
          console.error(`${error.name} : ${error.message}`);
        });
    })();
    return () => {
      isMounted = false;
    };
  }, []);
  const headerText = (
    <Grid size={12}>
      <Typography variant="h1" id="dashboard">
        Maintenance Dashboard
      </Typography>
    </Grid>
  );
  const handleSubmit = async () => {
    await fetch(
      `${ApiBaseUrl()}/maintenance?token=${token}&user=${user}&is_active=${status}&description=${description}&title=${title}&disable_content=${disable}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "appliction/json",
          "x-rate-limit": "off",
        },
        body: JSON.stringify({
          data: {
            is_active: status,
            description: description,
            ID: "maintenance",
            title: title,
            disable_content: disable,
            user: getCookiebyName("uuid"),
          },
        }),
      },
    )
      .catch((error) => {
        console.error(error);
        return error;
      })
      .finally(() => {
        window.location.reload();
      });
  };
  const handleCancel = () => {
    setTitle(bannerData.title);
    setStatus(bannerData.is_active);
    setDescription(bannerData.description);
    setDisable(bannerData.disabled);
  };
  return (
    <>
      <CloudFoundryBanner />
      <Grid
        style={{ position: "relative" }}
        size={{
          sm: 12,
          xs: 12,
        }}
      >
        {headerText}
      </Grid>
      <Grid
        container
        direction="column"
        spacing={2}
        sx={{
          justifyContent: "flex-end",
          alignItems: "right",
        }}
      >
        <Grid>
          <InputLabel>Is Active</InputLabel>
          <Select value={status} onChange={handleStatusChange}>
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
          </Select>
        </Grid>
        <Grid>
          <InputLabel>Disable Custom Content</InputLabel>
          <Select value={disable} onChange={handleDisableChange}>
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
          </Select>
        </Grid>
        <Grid>
          <InputLabel>Title</InputLabel>
          <TextField
            id="maintenance_title"
            style={{ minWidth: 1000 }}
            value={title}
            onChange={handleTitleChange}
          ></TextField>
        </Grid>
        <Grid>
          <InputLabel>Description</InputLabel>
          <TextField
            multiline
            id="maintenance_description"
            style={{ minWidth: 1000 }}
            value={description}
            onChange={handleDescriptionChange}
          />
        </Grid>
      </Grid>
      <Grid spacing={2} container style={{ paddingTop: 16 }}>
        <Grid>
          <Button onClick={handleSubmit} variant="contained">
            Save
          </Button>
        </Grid>
        <Grid>
          <Button onClick={handleCancel} variant="contained">
            Cancel
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
